export default __webpack_public_path__ + "static/media/EM1350.34I-36495_-21469_0.189d354e.jpg";